<script>
import * as LucideIcons from 'lucide-vue-next'

export default {
  name: 'LegacySideBarDropDown',
  props: {
    title: { type: String, default: '' },
    headerIcon: { type: String, default: '' },
    links: { type: Array, default: () => [] },
  },
  data() {
    return { open: this.computeInitialOpen() }
  },
  computed: {
    headerIconComponent() {
      return this.headerIcon ? LucideIcons[this.headerIcon] : null
    },
    chevronIcon() {
      return this.open ? LucideIcons.ChevronDown : LucideIcons.ChevronRight
    },
  },
  watch: {
    $route() {
      if (this.matchesRoute()) this.open = true
    },
  },
  methods: {
    iconFor(name) {
      return name ? LucideIcons[name] : null
    },
    isActive(link) {
      return link.route && this.$route && this.$route.path === link.route
    },
    matchesRoute() {
      return (this.links || []).some((l) => this.isActive(l))
    },
    computeInitialOpen() {
      return (this.links || []).some(
        (l) => l.route && this.$route && this.$route.path === l.route
      )
    },
    handleClick(link) {
      if (link.title) this.$emit(link.title)
    },
  },
}
</script>

<template>
  <div class="px-2 mb-1">
    <button
      type="button"
      class="w-full flex items-center gap-2 rounded-md px-2 py-2 text-sm font-medium text-foreground hover:bg-muted transition-colors"
      @click="open = !open"
    >
      <component
        v-if="headerIconComponent"
        :is="headerIconComponent"
        class="w-4 h-4 text-foreground/80"
      />
      <span class="flex-1 text-left">{{ title }}</span>
      <component :is="chevronIcon" class="w-4 h-4 text-foreground/60" />
    </button>
    <div v-show="open" class="mt-1 ml-3 border-l border-border pl-2 space-y-0.5">
      <button
        v-for="(link, i) in links"
        :key="i"
        type="button"
        :class="[
          'w-full flex items-center gap-2 rounded-md px-2 py-1.5 text-sm transition-colors',
          isActive(link)
            ? 'bg-muted text-foreground font-medium'
            : 'text-foreground/80 hover:bg-muted hover:text-foreground',
        ]"
        @click="handleClick(link)"
      >
        <component
          v-if="iconFor(link.icon)"
          :is="iconFor(link.icon)"
          class="w-4 h-4 flex-shrink-0"
        />
        <span class="truncate text-left">{{ link.text }}</span>
      </button>
    </div>
  </div>
</template>
